import { HookFormImageUploadInput } from '@realtyka/real-ui';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  AGENT_ACCEPTED_FILE_TYPES,
  AGENT_MAX_FILE_SIZE,
} from '../../../../constants/FileConstants';
import { FieldObject } from '../../../../openapi/atlantis';
import { useAgentFileUpload } from '../../../../hooks/useAgentFileUpload';
import { useChecklistItem } from '../../../../hooks/useChecklistItem';
import { getInputValidations } from '../../../../utils/Validations';

interface SingleFileInputCardV2Props {
  name: string;
  field: FieldObject;
  checklistItemId: string;
}

const SingleFileInputCardV2: React.FC<SingleFileInputCardV2Props> = ({
  name,
  field,
  checklistItemId,
}) => {
  const { control, setValue, watch } = useFormContext();

  // Use custom hooks for checklist and file upload
  const { files, setFileReferences } = useChecklistItem(checklistItemId);
  const { handleFileChange, handleFileDelete, resetFormState } =
    useAgentFileUpload({
      name,
      checklistItemId,
      files,
      setValue,
      watch,
      setFileReferences,
      validatePDF: true,
    });

  // Reset form state when checklistItemId changes
  useEffect(() => {
    resetFormState();
  }, [checklistItemId, resetFormState]);

  return (
    <HookFormImageUploadInput
      key={checklistItemId}
      name={name}
      control={control}
      label={field.label}
      rules={getInputValidations(field)}
      onChange={handleFileChange}
      onDelete={handleFileDelete}
      accept={AGENT_ACCEPTED_FILE_TYPES}
      maxSize={AGENT_MAX_FILE_SIZE}
      fileTypeHint='Please upload only image or document files up to 5MB.'
    />
  );
};

export default SingleFileInputCardV2;
